import Vue from 'vue'
import App from './App.vue'
import './plugins/iview.js'
import axios from './libs/http/interceptor';

import animate from 'animate.css'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper,animate)
Vue.prototype.$http = axios;
Vue.config.productionTip = false
import './themes/custom.less'
import router from './router'

router.beforeEach((to, from, next) => {
  const type = to.meta.type;

  if (type === 'login') {
    if (window.localStorage.getItem('login')) {
      next();
    } else {
      next('/login');
    }
  } else {
    next();
  }

})


Vue.config.productionTip = false

new Vue({
  axios,
  router,
  render: h => h(App)
}).$mount('#app')
